// The one place that decides where an entity link goes.

const withTab = (path, tab) => (tab ? `${path}?tab=${encodeURIComponent(tab)}` : path);

export const cvePath = (cve, tab) => withTab(`/vulnerabilities/${encodeURIComponent(cve)}`, tab);

// Without an id only the name is known, so the link opens the filtered Packages list.
export const packagePath = ({ id, name }, tab) => {
  if (id === undefined || id === null) return `/packages?kw=${encodeURIComponent(name)}`;
  return withTab(`/packages/${encodeURIComponent(id)}`, tab);
};

// Without an id (ticket items only store the hostname) the link opens the filtered Hosts list.
export const hostPath = ({ id, name }, tab) => {
  if (id === undefined || id === null) return `/hosts?kw=${encodeURIComponent(name)}`;
  return withTab(`/hosts/${encodeURIComponent(id)}`, tab);
};

export const ticketPath = (id) => `/tickets/${encodeURIComponent(id)}`;

// Host Ownership filtered to the host, with the edit panel open when the name is an exact hostname.
export const ownershipPath = (hostname) => {
  if (!hostname) return '/host-ownership';
  const name = encodeURIComponent(hostname);
  return `/host-ownership?kw=${name}&edit=${name}`;
};
